module.exports = __webpack_public_path__ + "img/logo-aqu-white.e7990ce3.png";